module.exports = __webpack_public_path__ + "media/organizations/UNI-7fa6a453.webp";